import { Deployment } from 'types/deployment';

import { useMqttDeploymentLogs } from 'deployments/hooks/useMqttDeploymentLogs';

import { Logs } from 'components/Logs/Logs';

export type DeploymentDetailLogsProps = {
  deployment: Deployment;
};

export function DeploymentLogs({ deployment }: DeploymentDetailLogsProps) {
  const logs = useMqttDeploymentLogs(deployment);

  const isActive =
    deployment.state === 'deploying' ||
    deployment.state === 'running' ||
    deployment.state === 'restart_waiting';

  const message = isActive
    ? 'Function node output will appear here...'
    : 'Start deployment to see function node output.';

  return <Logs logs={logs} emptyMessage={message} />;
}
